import * as CoreActions from './core.action';
import { createReducer, on } from '@ngrx/store';
export const coreFeatureKey = 'core';

export interface State {
    me: any,
    locations: any[],
    isSideNavOpen: boolean,
    isSideNavCollapsed: boolean,
    title: string,
    error_message: any,
    show_location: boolean,
    show_serialpattern: boolean
}

export const initialState: State = {
    me: null,
    locations: null,
    isSideNavOpen: false,
    isSideNavCollapsed: false,
    title: null,
    error_message: null,
    show_location: true,
    show_serialpattern: true
}

export const reducer = createReducer(
    initialState,
    on(CoreActions.login, (state, action) => {
        return {
            ...state,
            action
        }
    }),
    on(CoreActions.setIsSideNavOpen, (state, action) => ({
        ...state,
        isSideNavOpen: action.isSideNavOpen
    })),
    on(CoreActions.setIsSideNavCollapsed, (state, action) => ({
        ...state,
        isSideNavCollapsed: action.isSideNavCollapsed
    })),
    on(CoreActions.loadLocationsSuccess, (state, action) => ({
        ...state,
        locations: action.locations
    })),
    on(CoreActions.loadMe, (state, action) => state),
    on(CoreActions.loadMeSuccess, (state, action) => ({
        ...state,
        me: action.user
    })),
    on(CoreActions.updateMe, (state, action) => state),
    on(CoreActions.setTitle, (state, action) => ({
        ...state,
        title: action.title
    })),
    on(CoreActions.resetMe, (state, action) => ({
        ...state,
        me: []
    })),
    on(CoreActions.showErrorMessage, (state, action) => ({
        ...state,
        error_message: action
    })),
    on(CoreActions.increaseCurrentLimit, (state, action) => {
        var increase_count = 1;
        if(action.increase_count!==undefined && action.increase_count && action.increase_count>0){
            increase_count = action.increase_count;
        }

        if (action.types === 'users') {
          const updatedCurrentUsersCount = state.me.settingQtyCurrent.user_count + increase_count;

          return {
              ...state,
              me: {
                ...state.me,
                settingQtyCurrent: {
                  ...state.me.settingQtyCurrent,
                  user_count: updatedCurrentUsersCount,
                },
              },
          };
        }


        if (action.types === 'products') {
            const updatedProductCount = state.me.settingQtyCurrent.product_count + increase_count;

            return {
                ...state,
                me: {
                    ...state.me,
                    settingQtyCurrent: {
                    ...state.me.settingQtyCurrent,
                    product_count: updatedProductCount,
                    },
                },
            };
        }

        if (action.types === 'areas') {
            const updatedAreaCount = state.me.settingQtyCurrent.area_count + increase_count;

            return {
            ...state,
            me: {
                ...state.me,
                settingQtyCurrent: {
                ...state.me.settingQtyCurrent,
                area_count: updatedAreaCount,
                },
            },
            };
        }

        if (action.types === 'categories') {
            const updatedCategoryCount = state.me.settingQtyCurrent.category_count + increase_count;

            return {
            ...state,
            me: {
                ...state.me,
                settingQtyCurrent: {
                ...state.me.settingQtyCurrent,
                category_count: updatedCategoryCount,
                },
            },
            };
        }

        if (action.types === 'counts') {
            const updatedCountCount = state.me.settingQtyCurrent.count_count + increase_count;

            return {
            ...state,
            me: {
                ...state.me,
                settingQtyCurrent: {
                ...state.me.settingQtyCurrent,
                count_count: updatedCountCount,
                },
            },
            };
        }

        return state;
      }),
      on(CoreActions.decreaseCurrentLimit, (state, action) => {

        var decrease_count = 1;
        if(action.decrease_count!==undefined && action.decrease_count && action.decrease_count>0){
            decrease_count = action.decrease_count;
        }


        if (action.types === 'users') {
          const updatedCurrentUsersCount = state.me.settingQtyCurrent.user_count - decrease_count;

          return {
              ...state,
              me: {
                ...state.me,
                settingQtyCurrent: {
                  ...state.me.settingQtyCurrent,
                  user_count: updatedCurrentUsersCount,
                },
              },
          };
        }

        if (action.types === 'products') {
            const updatedProductCount = state.me.settingQtyCurrent.product_count - decrease_count;

            return {
                ...state,
                me: {
                    ...state.me,
                    settingQtyCurrent: {
                    ...state.me.settingQtyCurrent,
                    product_count: updatedProductCount,
                    },
                },
            };
        }

        if (action.types === 'areas') {
            const updatedAreaCount = state.me.settingQtyCurrent.area_count - decrease_count;

            return {
            ...state,
            me: {
                ...state.me,
                settingQtyCurrent: {
                ...state.me.settingQtyCurrent,
                area_count: updatedAreaCount,
                },
            },
            };
        }

        if (action.types === 'categories') {
            const updatedCategoryCount = state.me.settingQtyCurrent.category_count - decrease_count;

            return {
            ...state,
            me: {
                ...state.me,
                settingQtyCurrent: {
                ...state.me.settingQtyCurrent,
                category_count: updatedCategoryCount,
                },
            },
            };
        }

        if (action.types === 'counts') {
            const updatedCountCount = state.me.settingQtyCurrent.count_count - decrease_count;

            return {
            ...state,
            me: {
                ...state.me,
                settingQtyCurrent: {
                ...state.me.settingQtyCurrent,
                count_count: updatedCountCount,
                },
            },
            };
        }

        return state;
      })

);
